import { render, staticRenderFns } from "./channel-params.vue?vue&type=template&id=7f0f0b0c"
import script from "./channel-params.vue?vue&type=script&lang=js"
export * from "./channel-params.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports